import React from 'react';
import { useTranslation } from 'react-i18next';
import { MetricCard } from '@components/MetricCard';
import { UserMetrics } from '../types';

interface UserMetricsProps {
  metrics: UserMetrics | null;
}

export const UserMetricsCards: React.FC<UserMetricsProps> = ({ metrics }) => {
  const { t } = useTranslation();
  if (!metrics) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {[1, 2, 3, 4].map(i => (
          <MetricCard key={i} title={t('common.loading')} value="" loading={true} />
        ))}
      </div>
    );
  }

  const metricCards = [
    {
      title: t('users.totalUsers'),
      value: metrics.total_users,
      icon: 'people',
      variant: 'primary' as const,
      trend: t('users.allUsersInOrganization'),
      trendType: 'neutral' as const,
    },
    {
      title: t('users.activeUsers'),
      value: metrics.active_users,
      icon: 'check_circle',
      variant: 'success' as const,
      trend: t('users.currentlyActiveUsers'),
      trendType: 'positive' as const,
    },
    {
      title: t('users.pendingInvitations'),
      value: metrics.pending_invitations,
      icon: 'pending',
      variant: 'warning' as const,
      trend: t('users.awaitingAcceptance'),
      trendType: 'neutral' as const,
    },
    {
      title: t('users.suspendedUsers'),
      value: metrics.suspended_users,
      icon: 'block',
      variant: 'error' as const,
      trend: t('users.temporarilyDisabled'),
      trendType: 'negative' as const,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {metricCards.map((card, index) => (
        <MetricCard
          key={index}
          title={card.title}
          value={card.value}
          icon={card.icon}
          variant={card.variant}
          trend={card.trend}
          trendType={card.trendType}
        />
      ))}
    </div>
  );
};
